import gql from 'graphql-tag';

export const MENTIONS_PLEX_REGISTERED_USER_FRAGMENT = gql`
  fragment mentionsPlexRegisteredUser on PlexRegisteredUser {
    email
    name
  }
`;
